// extracted by mini-css-extract-plugin
module.exports = {"iframe":"PdfViewer_iframe__1TnvG","root":"PdfViewer_root__1FHIm","panel":"PdfViewer_panel__1ib5Y","h2":"PdfViewer_h2__2O7GD"};